<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 border border-blueGray-200 rounded-lg bg-white"
  >
    <div class="rounded-t mb-0 px-4 py-3 border-0">
      <div class="flex flex-wrap items-center justify-between">
        <div class="relative px-4">
          <h3
            class="text-lg text-blueGray-700"
          >
          <i class="pi mx-2 text-sm pi-users"></i> User
          </h3>
        </div>

        <div class="flex flex-wrap items-center mb-3" style="gap: 0.25rem;">
          <button
            v-for="preset in datePresets"
            :key="preset.label"
            type="button"
            class="text-xs px-3 py-2 rounded outline-none focus:outline-none mr-1"
            :class="activePreset === preset.label
              ? 'bg-blueGray-900 text-white'
              : 'bg-blueGray-200 text-blueGray-600 hover:bg-blueGray-300'"
            @click="applyDatePreset(preset)"
          >
            {{ preset.label }}
          </button>
          <button
            class="bg-blueGray-900 text-white active:bg-blueGray-800 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150 max-w-full"
            type="button"
            :disabled="loading"
            @click="toggleModal('filter', true)"
          >
          <i class="pi pi-filter text-xs" style="font-size: 10px;"></i> Filter
          </button>
          <button
                v-if="has('user.register.create')"
                class="bg-blueGray-900 text-white active:bg-blueGray-800 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150 max-w-full"
                type="button" 
                :disabled="loading"
                @click="toggleModal('createUser', true)"
              >
              <i class="pi pi-user-plus text-xs" style="font-size: 10px;"></i> Create User
              </button>
          <button
                v-if="has('business.join.update')"
                class="bg-blueGray-900 text-white active:bg-blueGray-800 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150 max-w-full"
                type="button"
                :disabled="loading"
                @click="openAddToCluster"
              >
              <i class="pi pi-users text-xs" style="font-size: 10px;"></i> Add to Cluster
              </button>
          <button
            class="bg-blueGray-900 text-white active:bg-blueGray-800 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150 max-w-full"
            type="button"
            :disabled="loading"
            @click="get_csv=true;fetchNewUserPage()"
          >
          <i class="pi pi-download text-xs" style="font-size: 10px;"></i> Download
          </button>
        </div>

      </div>
    </div>


    <div class="block w-full overflow-x-auto">
      <!-- Projects table -->
      <table class="items-center w-full bg-transparent border-collapse">
        <thead>
          <tr>
            <th
              class="px-6 align-middle border border-solid py-3 text-xs border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
            >
              <i class="pi pi-user mr-1"></i>Name
            </th>
            <th
              class="px-6 align-middle border border-solid py-3 text-xs border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
            >
              <i class="pi pi-envelope mr-1"></i>Email
            </th>
            <th
              class="px-6 align-middle border border-solid py-3 text-xs border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
            >
              <i class="pi pi-phone mr-1"></i>Phone
            </th>
            <th
              class="px-6 align-middle border border-solid py-3 text-xs border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
            >
              <i class="pi pi-verified mr-1"></i>Verified
            </th>
            
            <th
              class="px-6 align-middle border border-solid py-3 text-xs border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
            >
              <i class="pi pi-wallet mr-1"></i>Naira Balance <br />
              <small>
                (Ledger/Balance)
              </small>
            </th>
            <!-- <th
              class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
            >
              <i class="pi pi-wallet mr-1"></i>USD Balance <br/>
              <small>
                (Ledger/Balance)
              </small>
            </th> -->
            <!-- <th
              class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
            >
              <i class="pi pi-wallet mr-1"></i>USDT Balance<br/>
              <small>
                (Ledger/Balance)
              </small>
            </th> -->
            <th
              class="px-6 align-middle border border-solid py-3 text-xs border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
            >
              <i class="pi pi-calendar mr-1"></i>Creation Date
            </th>
            <th
              class="px-6 align-middle border border-solid py-3 text-xs border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
            ></th>
          </tr>
        </thead>
        <tbody>
          <template v-if="!loaders().getAllUsers">
          <tr v-for="(user, i) in users().data" :key="i">
            <th
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left flex items-center"
              @click="(e) => {
                setUser(user); 
                toggleModal('userInformation', true)
              }"
            >
              <img
                v-if="user.profile?.image && user.profile?.image.length > 5"
                :src="$_get_image_url(user.profile?.image)"
                class="h-12 w-12 bg-white rounded-full border"
                alt="..."
              />
              <div v-else class="h-12 w-12 bg-white rounded-full border flex justify-center items-center">
                {{ getInitials(user.name) }}
              </div>
              <span
                class="ml-3 font-bold text-blueGray-600"
                :class="[user.is_blocked ? 'line-through italic' : '']"
              >
                {{ user.name }}
              </span>
            </th>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
              @click="clickToCopy(user.email)"
            >
            <span :class="[
              user.is_blocked ? 'line-through italic' : ''
            ]">
              {{ user.email }} <i v-if="user.email" class="pi pi-clone text-xs" ></i>
            </span>
            </td>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
              @click="clickToCopy(user.profile?.phone)"
            >
              {{ user.profile?.phone }} <i v-if="user.email" class="pi pi-clone text-xs" ></i>
            </td>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <i :class="`fas fa-circle ${user.email_verified_at ? 'text-blueGray-900' :  'text-orange-500 '}  mr-2`"></i> {{ user.email_verified_at ? 'yes' : 'no' }}
            </td>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div class="flex items-center">
                <span class="mr-2">
                  {{ formatter(user.naira_wallet?.base_currency || "NGN").format(user.naira_wallet?.ledger_balance || 0) }} / 
                  {{ formatter(user.naira_wallet?.base_currency || "NGN").format(user.naira_wallet?.balance || 0) }}
                </span>
              </div>
            </td>
            <!-- <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div class="flex items-center">
                <span class="mr-2">
                  {{ user.usd_wallet?.base_currency }}
                  {{ user.usd_wallet?.ledger_balance }} / 
                  {{ user.usd_wallet?.base_currency }}
                  {{ user.usd_wallet?.balance }}
                </span>
              </div>
            </td> -->
            <!-- <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div class="flex items-center">
                <span class="mr-2">
                  {{ user.usdt_wallet?.base_currency }}
                  {{ user.usdt_wallet?.ledger_balance }} / 
                  {{ user.usdt_wallet?.base_currency }}
                  {{ user.usdt_wallet?.balance }}
                </span>
              </div>
            </td> -->
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div class="flex items-center">
                <span class="mr-2">
                  {{ moment(user.created_at).format("DD MMM YY hh:mm") }}
                </span>
              </div>
            </td>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-right"
            >
              <table-dropdown 
                :user="user" 
                @add-saving-plan-click="(e) => {setUser(user); toggleModal('addToSavingsPlan', true)}" 
                @view-info-click="(e) => {setUser(user); toggleModal('userInformation', true)}"
              />
            </td>
          </tr>
          </template>
          <template v-else>
            <tr v-for="n in 6" :key="n">
              <td v-for="col in 7" :key="col" class="border-t-0 px-6 align-middle border-l-0 border-r-0 p-4">
                <div class="h-3 bg-blueGray-200 rounded animate-pulse" :style="{ width: ['85%','60%','70%','50%','65%','55%','45%'][(col-1) % 7] }"></div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <empty-list v-if="(!users().data || users().data.length === 0) && !loaders().getAllUsers"></empty-list>
    </div>
    <div class="flex flex-wrap items-center">
      <div class="relative w-full px-4 max-w-full flex-grow flex-1">
        <circular-pagination :current_page="users().current_page" :last_page="users().last_page" :size="pageSize" @paginate="pageChange" ></circular-pagination>
      </div>
    </div>

    <div v-if="modals.createUser" style="width: 100%;" class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex w-screen h-screen top-0 left-0">
      <div class="relative w-auto my-6 mx-auto">
        <!--content-->
        <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <!--header-->
          <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
            <h3 class="text-xl font-semibold">
              Create User
            </h3>
            <button 
              class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" 
              v-on:click="toggleModal('createUser', false)"
            >
              <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                ×
              </span>
            </button>
          </div>
          <!--body-->
          <div class="relative p-6 flex-auto">
            <form>
              <div v-if="stage === stages.OTP_FORM">
                <h6 class="text-blueGray-400 text-sm mt-3 mb-6">
                  Validation
                </h6>
                <div class="flex flex-wrap">
                  <div class="w-full">
                    <div class="relative w-full mb-3">
                      <label
                        class="block text-blueGray-600 text-xs mb-2"
                        htmlFor="grid-password"
                      >
                        OTP
                      </label>
                      <input
                        type="text"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none   w-full ease-linear transition-all duration-150"
                        v-model="v$.otp.$model"
                      />
                      <div class="input-errors text-xs text-danger mt-2" v-for="(error, index) of v$.otp.$errors" :key="index">
                        <div class="error-msg">{{ error.$message }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="relative w-full mb-3 mt-8" v-if="has('user.proxy-create.ability')">
                  <button
                    class="bg-blueGray-900 text-white active:bg-blueGray-800 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150 w-full"
                    type="button"
                    @click="validateAndRegister" 
                    :disabled="loaders().validateCode || loaders().registerUserProxy || v$.otp.$invalid" 
                  >
                    Validate & Create
                  </button>
                </div>
              </div>
              <div v-else-if="stage === stages.COMPLETED">
                <div class="flex justify-center items-center h-8">
                  User Added Successfully.
                </div>
              </div>
              <div v-else>
                <h6 class="text-blueGray-400 text-sm mt-3 mb-6">
                  User Information
                </h6>
                <div class="flex flex-wrap">
                  <div class="w-full">
                    <div class="relative w-full mb-3">
                      <label
                        class="block text-blueGray-600 text-xs mb-2"
                        htmlFor="grid-password"
                      >
                        name
                      </label>
                      <input
                        type="text"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none   w-full ease-linear transition-all duration-150"
                        v-model="v$.user.name.$model"
                      />
                      <div class="input-errors text-xs text-danger mt-2" v-for="(error, index) of v$.user.name.$errors" :key="index">
                        <div class="error-msg">{{ error.$message }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="w-full">
                    <div class="relative w-full mb-3">
                      <label
                        class="block text-blueGray-600 text-xs mb-2"
                        htmlFor="grid-password"
                      >
                        Phone 
                      </label>
                      <input
                        type="text"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none   w-full ease-linear transition-all duration-150"
                        v-model="v$.user.phone.$model"
                      />
                      <div class="input-errors text-xs text-danger mt-2" v-for="(error, index) of v$.user.phone.$errors" :key="index">
                        <div class="error-msg">{{ error.$message }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="w-full">
                    <div class="relative w-full mb-3">
                      <label
                        class="block text-blueGray-600 text-xs mb-2"
                        htmlFor="grid-password"
                      >
                        Email 
                      </label>
                      <input
                        type="text"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none   w-full ease-linear transition-all duration-150"
                        v-model="v$.user.email.$model"
                      />
                      <div class="input-errors text-xs text-danger mt-2" v-for="(error, index) of v$.user.email.$errors" :key="index">
                        <div class="error-msg">{{ error.$message }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="relative w-full mb-3 mt-8" v-if="has('user.init.ability')">
                  <button
                    class="bg-blueGray-900 text-white active:bg-blueGray-800 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150 w-full"
                    type="button"
                    @click="validateAndSendCode" 
                    :disabled="loaders().registerUserInit || v$.user.$invalid" 
                  >
                    Continue
                  </button>
                </div>
              </div>

              <div class="input-errors text-xs text-danger mt-2" v-for="([key, error], index) of Object.entries(errors)" :key="index">
                <div class="error-msg">{{ key }}: {{ error }}</div>
              </div>

            </form>

          </div>
          <!--footer-->
          <div class="flex items-center justify-end p-4 border-t border-solid border-blueGray-200 rounded-b">
            <button 
              class="text-red-500 background-transparent px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" 
              v-on:click="toggleModal('createUser', false)"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="modals.createUser" style="width: 100%; opacity: 0.25;" class="opacity-25 fixed inset-0 z-40 h-screen top-0 left-0 bg-black"></div>

    <div v-if="modals.addToSavingsPlan" style="width: 100%;" class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex w-screen h-screen top-0 left-0">
      <div class="relative w-auto my-6 mx-auto">
        <!--content-->
        <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <!--header-->
          <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
            <h3 class="text-xl font-semibold">
              Add to Savings
            </h3>
            <button 
              class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" 
              v-on:click="toggleModal('addToSavingsPlan', false)"
            >
              <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                ×
              </span>
            </button>
          </div>
          <!--body-->
          <div class="relative p-6 flex-auto">
            <form>
              <div v-if="stage === stages.PREVIEW">
                <h6 class="text-blueGray-400 text-sm mt-3 mb-6">
                  Confirm
                </h6>
                <div class="flex flex-wrap">
                  <div class="w-full">
                    Confirm you want to add {{ user.name }} to {{ planUser.name }} savings plan.
                  </div>
                </div>
                <div class="relative w-full mb-3 mt-8">
                  <button
                    class="bg-blueGray-900 text-white active:bg-blueGray-800 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150 w-full"
                    type="button"
                    @click="joinSubPlan" 
                    :disabled="loaders().joinPlan" 
                  >
                    Add User
                  </button>
                </div>
              </div>
              <div v-else-if="stage === stages.COMPLETED">
                <div class="flex justify-center items-center h-8">
                  User Added Successfully.
                </div>
              </div>
              <div v-else>
                <h6 class="text-blueGray-400 text-sm mt-3 mb-6">
                  Search Plan
                </h6>
                <div class="flex flex-wrap">
                  <div class="w-full px-4">
                    <div class="relative w-full mb-3">
                      <label
                        class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Code
                      </label>
                      <input
                        type="text"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none   w-full ease-linear transition-all duration-150"
                        v-model="v$.savingsPlanCode.$model"
                      />
                      <div class="input-errors text-xs text-danger mt-2" v-for="(error, index) of v$.savingsPlanCode.$errors" :key="index">
                        <div class="error-msg">{{ error.$message }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="relative w-full mb-3 px-4 mt-8">
                  <button
                    class="bg-blueGray-900 text-white active:bg-blueGray-800 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150 w-full"
                    type="button"
                    @click="findPlan" 
                    :disabled="loaders().fetchByCode || v$.savingsPlanCode.$invalid" 
                  >
                    Find Plan
                  </button>
                </div>
              </div>

              <div class="input-errors text-xs text-danger mt-2" v-for="([key, error], index) of Object.entries(errors)" :key="index">
                <div class="error-msg">{{ key }}: {{ error }}</div>
              </div>

            </form>

          </div>
          <!--footer-->
          <div class="flex items-center justify-end p-4 border-t border-solid border-blueGray-200 rounded-b">
            <button 
              class="text-red-500 background-transparent px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" 
              v-on:click="toggleModal('addToSavingsPlan', false)"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="modals.addToSavingsPlan" style="width: 100%; opacity: 0.25;" class="opacity-25 fixed inset-0 z-40 h-screen top-0 left-0 bg-black"></div>

    <!-- Add to Cluster -->
    <div v-if="modals.addToCluster" style="width: 100%;" class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex w-screen h-screen top-0 left-0">
      <div class="relative w-auto my-6 mx-auto">
        <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none" style="min-width: 380px;">
          <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
            <h3 class="text-xl font-semibold">
              Add to Cluster
            </h3>
            <button
              class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
              v-on:click="toggleModal('addToCluster', false)"
            >
              <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                ×
              </span>
            </button>
          </div>
          <div class="relative p-6 flex-auto">
            <div v-if="stage === stages.COMPLETED">
              <div class="flex justify-center items-center h-8">
                User Added to Your Cluster Successfully.
              </div>
            </div>
            <div v-else>
              <h6 class="text-blueGray-400 text-sm mt-3 mb-6">
                Search for an existing user to add to your cluster.
              </h6>
              <div class="w-full px-4">
                <user-search-select v-model="clusterUser" />
              </div>

              <div class="input-errors text-xs text-danger mt-2 px-4" v-for="([key, error], index) of Object.entries(errors)" :key="index">
                <div class="error-msg">{{ key }}: {{ error }}</div>
              </div>

              <div class="relative w-full mb-3 px-4 mt-8">
                <button
                  class="bg-blueGray-900 text-white active:bg-blueGray-800 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150 w-full disabled:opacity-50"
                  type="button"
                  @click="addToCluster"
                  :disabled="loaders().joinBusiness || !clusterUser"
                >
                  Add to Cluster
                </button>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-end p-4 border-t border-solid border-blueGray-200 rounded-b">
            <button
              class="text-red-500 background-transparent px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button"
              v-on:click="toggleModal('addToCluster', false)"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="modals.addToCluster" style="width: 100%; opacity: 0.25;" class="opacity-25 fixed inset-0 z-40 h-screen top-0 left-0 bg-black"></div>

    <div v-if="modals.userInformation" style="width: 100%;" class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex w-screen h-screen top-0 left-0">
      <div class="relative w-auto my-6 mx-auto">
        <!--content-->
        <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <!--header-->
          <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
            <h3 class="text-xl font-semibold">
              User Information
            </h3>
            <button 
              class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" 
              v-on:click="toggleModal('userInformation', false)"
            >
              <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                ×
              </span>
            </button>
          </div>
          <!--body-->
          <div class="relative p-6 flex-auto">
            <table>
              <tbody>
                <tr
                v-for="([k, v], i) in Object.entries(user)" :key="i"
                class="border-b-1 border-t-1"
                >
                  <template v-if="!['id', 'is_password_auto_gen', 'usd_wallet', 'usdt_wallet', 'btc_wallet', 'eth_wallet'].includes(k)">
                    <td
                    class="border-t-1 border-b-1 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-1 text-left"
                    >{{ k.split("_").join(" ") }}</td> 
                    <td class="border-t-1 border-b-1 px-6 align-middle border-l-0 border-r-0 text-xs text-left flex items-center">
                      <template v-if="(typeof v === 'object') && v !== null">
                        <hr/>
                        <table class="border-t-1 py-2">
                          <tbody>
                            <tr
                            v-for="([a, b], j) in Object.entries(v)" :key="j"
                            >
                              <template v-if="!['id', 'user_id', 'image', 'lien', 'is_frozen', 'deleted_at'].includes(a)">
                                <td>{{ a.split("_").join(" ") }}</td>
                                <td>{{ b }}</td>
                              </template>
                            </tr>
                          </tbody>
                        </table>
                      </template>
                      <template v-else>
                        {{ v }}
                      </template>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
          <!--footer-->
          <div class="flex items-center justify-end p-4 border-t border-solid border-blueGray-200 rounded-b">
            <button 
              class="text-red-500 background-transparent px-3 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" 
              v-on:click="toggleModal('userInformation', false)"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="modals.userInformation" style="width: 100%; opacity: 0.25;" class="opacity-25 fixed inset-0 z-40 h-screen top-0 left-0 bg-black"></div>

    <filter-modal 
      :selects="{
        email_verified: ['yes', 'no'], 
        phone_verified: ['yes', 'no'],
        referred: ['yes', 'no'],
        blocked: ['yes', 'no'],
        auto_gen: ['yes', 'no']
      }"
      :dates="{
        from: 'Start Date',
        to: 'End Date'
      }"
      :searchable="true"
      :sizable="true"
      :visible="modals.filter" 
      @close="modals.filter=false" 
      title="user"
      @filter="filter"
      :loading="loaders().getAllUsers"
    ></filter-modal>
    
  </div>
</template>
<script>
import TableDropdown from "@/components/Dropdowns/UserTableDropdown.vue";
import CircularPagination from "@/components/Paginations/CircularPagination.vue";
import useVuelidate from '@vuelidate/core';
import { required, minLength, maxLength } from '@vuelidate/validators';
import { mapActions, mapGetters } from 'vuex';
import { createToaster } from "@meforma/vue-toaster";
import FilterModal from "@/components/Modals/FilterModal.vue";
import UserSearchSelect from "@/components/Form/UserSearchSelect.vue";
import EmptyList from "@/components/Cards/EmptyList.vue";
import moment from "moment"
import { images } from '@/mixins'
import { getInitials, formatter, clickToCopy } from "@/utils"

const toaster = createToaster({ /* options */ });

export default {
  data() {
    return {
      pageSize: 10,
      timer: null,
      params: {},
      loading: false,
      get_csv: false,
      pagination:{},
      modals: {},
      user: {},
      stages: {
        CREATE_FORM: 'create-form',
        OTP_FORM: 'otp-form',
        PREVIEW: 'preview',
        COMPLETED: 'completed'
      },
      stage: "",
      errors: {},
      otp: "",
      savingsPlanCode: "",
      planUser: null,
      clusterUser: null,
      activePreset: null,
      datePresets: [
        { label: 'Today', days: 1 },
        { label: '7D', days: 7 },
        { label: '30D', days: 30 }
      ]
    };
  },
  components: {
    TableDropdown,
    CircularPagination,
    FilterModal,
    UserSearchSelect,
    EmptyList
  },
  props: {
    color: {
      default: "light",
      validator: function (value) {
        // The value must match one of these strings
        return ["light", "dark"].indexOf(value) !== -1;
      },
    },
  },
  setup () {
    return { v$: useVuelidate() }
  },
  mixins: [images],
  validations() {
    return {
      user: {
        name: { required },
        phone: { required },
        email: { required }
      },
      otp: { required, min: minLength(6), max: maxLength(7) },
      savingsPlanCode: { required, min: minLength(6), max: maxLength(7) },
    }
  },
  created() {
    this.moment = moment;
    this.getInitials = getInitials
    this.formatter = formatter
    this.clickToCopy = clickToCopy
  },
  methods: {
    ...mapActions(["getAllUsers", "logout", "registerUserInit", "fetchByCode", "joinPlan", "joinBusiness"]),
    ...mapGetters(["users", "loaders", "auth", "dashboard"]),
    pageChange(pagination) {
      this.pagination = pagination;
      this.fetchNewUserPage();
    },
    filter(params) {
      this.activePreset = null;
      this.params = params;
      this.fetchNewUserPage(params);
    },
    // Today/7D/30D shortcuts — reuses the exact same filter() path the modal's own
    // date pickers go through, so this stays consistent with manual date filtering
    // instead of being a parallel, easily-diverging mechanism.
    applyDatePreset(preset) {
      const toDate = new Date();
      const fromDate = new Date();
      fromDate.setDate(toDate.getDate() - (preset.days - 1));
      const toIso = d => d.toISOString().slice(0, 10);
      this.filter({ from: toIso(fromDate), to: toIso(toDate) });
      this.activePreset = preset.label;
    },
    fetchNewUserPage(p = {}) {
      const params = {
        ...this.pagination,
        get_csv: this.get_csv,
        ...this.params,
        ...p
      }
      const self = this
      this.loading = true
      this.getAllUsers(params).then( response => {
        if ( self.get_csv ) {
          // create file link in browser's memory
          const href = window.URL.createObjectURL(response);
          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download','users.csv'); //or any other extension
          document.body.appendChild(link);
          link.click();
          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);

          toaster.success("Report downloaded Successfully");
        }
      }).finally(() => {
        self.get_csv = false
        self.loading = false
      })
    },
    searchUser() {
      const self = this
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        self.fetchNewUserPage()
      }, 1000)
    },
    logoutUser: function() {
      this.logout().then(() => {
        const self = this;
        setTimeout( function(){
          self.$router.push('/auth');
        }, 900);
      }).catch( err => {
        console.log(err)
      })
    },
    toggleModal(modalName, isvisible) {
      this.setStage("");
      this.modals[modalName] = isvisible
    },
    validateAndSendCode() {
      const self = this
      this.registerUserInit(this.user).then( r => {
          console.log(r)
          self.setStage(self.stages.OTP_FORM)
      }).catch( e => {
          const { data } = e
          this.errors = data
      })
    },
    validateAndRegister() {
      if ( this.code.length !== 6 ) {
          return;
      }
      const self = this
      this.validateCode({
          email: this.user.email,
          code: this.code
      }).then( r => {
          console.log(r)
          const { settings, cluster } = self.auth()
          const { business } = self.dashboard()
          self.registerUserProxy({
              ...self.user,
              // referrer: settings.referrer_code,
              business: business ? business.uuid : cluster.uuid
          }).then( res => {
            console.log(res)
            self.setStage(self.stages.COMPLETED)
          }).catch( err => {
            console.log(err, settings)
          })
      }).catch( e => {
          console.log(e)
      })
    },
    setStage(stage) {
      this.errors = {}
      this.stage = stage
    },
    setUser(user) {
      this.user = user;
    },
    findPlan() {
      if ( !this.savingsPlanCode ) {
        this.errors = {message: "You cannot subscribe a user to this plan"}
        return
      }
      const self = this;
      this.fetchByCode(this.savingsPlanCode).then (r => {
        toaster.success("Kindly confirm plan " + r.name + ".")
        self.setStage(self.stages.PREVIEW)
        self.planUser = r;
      }).catch( e => {
        const { message } = e
        self.errors = { message }
      });
    },
    joinSubPlan() {
      if ( !this.savingsPlanCode ) {
        this.errors = {message: "You cannot subscribe a user to this plan"}
        return
      }
      const self = this
      this.joinPlan({user: this.user.id, code: this.savingsPlanCode}).then (r => {
        toaster.success("You have added " + self.user.name + " to plan " + r.name + ". Kindly reload.")
        self.setStage(self.stages.COMPLETED)
      }).catch( e => {
        const { message } = e
        this.errors = { message }
      });
    },
    openAddToCluster() {
      this.clusterUser = null
      this.errors = {}
      this.toggleModal('addToCluster', true)
    },
    addToCluster() {
      if ( !this.clusterUser ) {
        this.errors = { message: "Pick a user to add to your cluster" }
        return
      }

      // Same "am I a business owner or a cluster member" resolution used for
      // Create User above — either way it's my own business, identified by code
      // (joinBusiness looks up by code, not uuid).
      const { cluster } = this.auth()
      const { business } = this.dashboard()
      const myBusiness = business || cluster

      if ( !myBusiness || !myBusiness.code ) {
        this.errors = { message: "Could not determine your business. Please reload and try again." }
        return
      }

      const self = this
      this.joinBusiness({ code: myBusiness.code, user_id: this.clusterUser.id }).then(() => {
        toaster.success(self.clusterUser.name + " has been added to your cluster.")
        self.setStage(self.stages.COMPLETED)
      }).catch( e => {
        const { message } = e
        self.errors = { message }
      });
    },
  },
  mounted() {
    this.getAllUsers().then( r => {
      const { message } = r
      const self = this
      if ( message === "Unauthenticated." ) {
        self.logoutUser()
      }
    }).catch( e => {
      const { message } = e
      const self = this
      if ( message === "Unauthenticated." ) {
        self.logoutUser()
      }
    })
  }
};
</script>
